import {IconButtonProps} from "@mui/material/IconButton";
import {Box, Button, ButtonProps, IconButton, Tooltip} from "@mui/material";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import CreateIcon from "@mui/icons-material/Create";
import React, {useState} from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SearchIcon from '@mui/icons-material/Search';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

interface IconButtonWithTooltipProps extends IconButtonProps {
    tooltipTitle?: string
}

interface ButtonWithTooltipProps extends ButtonProps {
    tooltipTitle?: string
}

function IconButtonBase(props: IconButtonProps) {
    const {children, ...otherProps} = props;

    return (
        <IconButton
            sx={{
                gap: '12px',
                padding: '10px',
                borderRadius: "8px"
            }}
            {...otherProps}
        >
            {children}
        </IconButton>
    )
}

export const EditIconButton = ({tooltipTitle, ...props}: IconButtonWithTooltipProps) => {
    return (
        <>
            {
                tooltipTitle ?
                    <Tooltip title={tooltipTitle}>
                        <IconButton {...props}
                                    sx={{
                                                borderRadius: '0.75rem !important',
                                                border: '1px solid lightblue !important',
                                                padding: '5.8px !important',
                                                '&:hover': {
                                                    backgroundColor: 'lightblue !important',
                                                }
                                            }}
                                    size={'small'}
                        >
                            <CreateIcon color={'primary'} fontSize='small'/>
                        </IconButton>
                    </Tooltip>
                    :
                    <IconButton {...props}
                                sx={{
                                                borderRadius: '0.75rem !important',
                                                border: '1px solid lightblue !important',
                                                padding: '5.8px !important',
                                                '&:hover': {
                                                    backgroundColor: 'lightblue !important',
                                                }
                                            }}
                                size={'small'}
                    >
                        <CreateIcon color={'primary'} fontSize='small'/>
                    </IconButton>
            }
        </>
    )
}

export function BackButton({tooltipTitle, ...props}: ButtonWithTooltipProps) {
    return (
        <>
            {
                tooltipTitle ?
                    <Tooltip title={tooltipTitle}>
                        <Box>
                            <Button
                                variant={'contained'}
                                color={"inherit"}
                                startIcon={<KeyboardBackspaceIcon/>}
                                {...props}>
                                {props.children}
                            </Button>
                        </Box>
                    </Tooltip>
                    :
                    <Button
                        variant={'contained'}
                        color={"inherit"}
                        startIcon={<KeyboardBackspaceIcon/>}
                        {...props}>
                        {props.children}
                    </Button>
            }
        </>
    )
}


export const VisibilityIconButton = ({tooltipTitle, ...props}: IconButtonWithTooltipProps) => {
    return (
        <>
            {
                tooltipTitle ?
                    <Tooltip title={tooltipTitle}>
                        <IconButton {...props}
                                    sx={{border: '2px solid lightblue', borderRadius: '30px'}}
                                    size={'small'}
                        >
                            <VisibilityIcon color={'primary'} fontSize='small'/>
                        </IconButton>
                    </Tooltip>
                    :
                    <IconButton {...props}
                                sx={{border: '2px solid lightblue', borderRadius: '30px'}}
                                size={'small'}
                    >
                        <VisibilityIcon color={'primary'} fontSize='small'/>
                    </IconButton>
            }
        </>
    )
}


export const DeleteIconButton = ({tooltipTitle, ...props}: IconButtonWithTooltipProps) => {
    return (
        <>
            {
                tooltipTitle ?
                    <Tooltip title={tooltipTitle}>
                        <IconButton {...props}
                                    sx={{
                                                borderRadius: '0.75rem !important',
                                                border: '1px solid lightblue !important',
                                                padding: '5.8px !important',
                                                '&:hover': {
                                                    backgroundColor: 'lightblue !important',
                                                }
                                            }}
                                    size={'small'}
                        >
                            <DeleteIcon color={'primary'} fontSize='small'/>
                        </IconButton>
                    </Tooltip>
                    :
                    <IconButton {...props}
                                sx={{
                                                borderRadius: '0.75rem !important',
                                                border: '1px solid lightblue !important',
                                                padding: '5.8px !important',
                                                '&:hover': {
                                                    backgroundColor: 'lightblue !important',
                                                }
                                            }}
                                size={'small'}
                    >
                        <DeleteIcon color={'primary'} fontSize='small'/>
                    </IconButton>
            }
        </>
    )
}

interface ExpandIconProps extends IconButtonProps {
    initialExpanded?: 'expandLess' | 'expandMore',
    tooltipTitle?: string
}

export function ExpandIconButton({initialExpanded = 'expandLess', tooltipTitle, ...props}: ExpandIconProps) {
    const [expanded, setExpanded] = useState<'expandLess' | 'expandMore'>(initialExpanded)
    
    return (
        <Tooltip title={tooltipTitle || "Expandir"}>
            <Box>
                <IconButton
                    {...props}
                    sx={{
                        transform: expanded === 'expandMore' ? 'rotate(180deg)' : '',
                        transition: 'transform 100ms ease',
                        ...props.sx
                    }}

                    onClick={(e) => {
                        setExpanded(expanded === 'expandMore' ? 'expandLess' : 'expandMore')
                        props?.onClick && props.onClick(e)
                    }
                    }
                >
                    <ExpandLessIcon/>
                </IconButton>
            </Box>
        </Tooltip>
    )

}

export function DownloadIconButton({tooltipTitle, ...props}: IconButtonWithTooltipProps) {
    
    return (
        <>
            {
                tooltipTitle ?
                    <Tooltip title={tooltipTitle}>
                        <Box>
                            <IconButtonBase {...props} className={`${props.className}`} color={'primary'}
                                            sx={{
                                                borderRadius: '0.75rem !important',
                                                border: '1px solid lightblue !important',
                                                padding: '5.8px !important',
                                                '&:hover': {
                                                    backgroundColor: 'lightblue !important',
                                                }
                                            }}
                            >
                                <FileDownloadOutlinedIcon
                                    color='primary'
                                    fontSize='small'/>
                            </IconButtonBase>
                        </Box>
                    </Tooltip>
                    :
                    <IconButtonBase {...props} className={`${props.className}`} color={'primary'}
                                    sx={{
                                        borderRadius: '0.75rem !important',
                                        border: '1px solid lightblue !important',
                                        padding: '5.8px !important',
                                        '&:hover': {
                                            backgroundColor: 'lightblue !important',
                                        }
                                    }}
                    >
                        <FileDownloadOutlinedIcon
                            color='primary'
                            fontSize='small'/>
                    </IconButtonBase>
            }
        </>
    )
}


export const SearchIconButton = ({tooltipTitle, ...props}: IconButtonWithTooltipProps) => {

    return (
        <>
            {
                tooltipTitle ?
                    <Tooltip title={tooltipTitle}>
                        <Box>
                            <IconButtonBase {...props} className={`${props.className}`}
                                            sx={{
                                                borderRadius: '0.75rem !important',
                                                border: '1px solid lightblue !important',
                                                padding: '5.8px !important',
                                                '&:hover': {
                                                    backgroundColor: 'lightblue !important',
                                                }
                                            }}
                            >
                                <SearchIcon color='primary'
                                            fontSize='small'/>
                            </IconButtonBase>
                        </Box>
                    </Tooltip>
                    :
                    <IconButtonBase {...props} className={`${props.className}`}
                                    sx={{
                                        borderRadius: '0.75rem !important',
                                        border: '1px solid lightblue !important',
                                        padding: '5.8px !important',
                                        '&:hover': {
                                            backgroundColor: 'lightblue !important',
                                        }
                                    }}
                    >
                        <SearchIcon color='primary'
                                    fontSize='small'/>
                    </IconButtonBase>
            }
        </>
    )
}